<div class="ngx-activity-edit-panel" #panelWrapper>
	<div class="panel-header">
		<h1 class="modal-title" [translate]="headerOptions.editMode ? 'activity-editor-panel-header_edit' : 'activity-editor-panel-header_create'"></h1>
		<button
			class="close-btn btn-none"
			type="button"
			aria-label="{{'common_close' | translate}}"
			(click)="cancel()">
			<i class="ficon-app-x"></i>
		</button>
	</div>

	<div class="panel-body">
		<div class="panel-content">
			<ngx-activity-edit
				[activity]="activity"
				[hideName]="headerOptions.hideName">
			</ngx-activity-edit>
		</div>
	</div>

	<div class="panel-footer">
		<button
			type="button"
			class="tertiary-btn cancel-btn"
			[translate]="'common_cancel'"
			(click)="cancel()">
		</button>

		<button
			type="button"
			class="primary-btn submit-btn"
			data-cy="save-and-close"
			[disabled]="saving$ | async"
			[translate]="getPrimaryButtonText()"
			[focusOnFirstInvalidField]="{ formGroup: activityFormService.getForm(), formWrapper: panelWrapper }"
			(click)="save()">
		</button>
	</div>
</div>
